import type { ReactNode } from 'react'

import { usePanelPadding } from './Panel'
import { cn } from '@/components/base'
import { GroupHeading } from '@/components/Internal/GroupHeading'

/**
 * One block inside a `Panel`, at the inset the panel around it uses.
 *
 * A panel with more than one of these separates them with a hairline, which is
 * what lets a panel carry two kinds of content — a form and the thing it
 * produces — without a second frame around either.
 */
export function PanelSection({
  label,
  className,
  children,
}: {
  /** Names the block where a panel holds more than one kind of content. */
  label?: string
  className?: string
  children: ReactNode
}) {
  return (
    <div className={cn(usePanelPadding(), className)}>
      {label ? <GroupHeading title={label} className="mb-2" /> : null}
      {children}
    </div>
  )
}
